import Vue from 'vue';

export default {
  state: {
    jshaPage: {
      name: '',
      description: '',
      years: [],
    },
  },
  mutations: {
    setJshaPage(state, data) {
      state.jshaPage = data;
    },
  },
  actions: {
    getJshaPage(store) {
      const path = 'jsha';
      return Vue.prototype.$axios.get(path).then((resp) => {
        store.commit('setJshaPage', resp.data);
        return resp.data;
      });
    },
  },
};
